import { Component, OnInit, Input, SimpleChanges, forwardRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { environment } from '@app/environment';
import { MarvSelectComponent, MarvSelectItem } from '@marv/components';
import { OperationService } from '@app/services';

@Component({
    selector: 'app-type-mission-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    imports: [forwardRef(() => MarvSelectComponent)]
})
export class TypeMissionSelectComponent  implements OnInit {

    @Input({alias : 'label', required : false}) labelSelect: string = this.translateService.instant('TYPE_MISSION');
    @Input({alias : 'icon', required : false}) iconSelect: string = 'briefcase-outline';
    @Input({alias : 'formName', required : false}) formName: string|number = 'typeMissionId';
    @Input({alias : 'errorText', required : false}) errorText: string = '';
    @Input({alias : 'multiple', required : false}) multiple: boolean = false; 
    @Input({alias : 'displayItemsSelected', required : false}) displayItemsSelected: boolean = false;
    @Input({alias : 'typesMissions', required : false}) typesMissions: Array<MarvSelectItem>;
    @Input({alias : 'withSpeechToText', required : false}) withSpeechToText: boolean = false;

    items: Array<MarvSelectItem> = [];

    constructor(
        public translateService: TranslateService
    ) { }

    async ngOnInit() {        
        let items: Array<MarvSelectItem> = []
        if(typeof this.typesMissions !== 'undefined'){
            items = this.typesMissions;
        }
        else{   
            let operationsTypesMissions = OperationService.Operations.map(o => o.typeOfMissionCode) || [];
            for(let type of environment.MISSIONS_TYPES){
                if(operationsTypesMissions.indexOf(type.code) !== -1){
                    items.push({
                        label: this.translateService.instant(type.name),
                        value: type.code,
                        color: type.color
                    });
                }
            }            
        }
        this.items = items;
    }
    
    async ngOnChanges(changes: SimpleChanges) {     
        if(changes['typesMissions'] && changes['typesMissions'].currentValue){ 
            if(typeof this.typesMissions !== 'undefined'){
                this.items = this.typesMissions;
            }
        }
    }
}
